// Chart Color Scheme: http://paletton.com/#uid=72O0T0ktEpZ3XGDjWudDLiIWY8k

export const BLUE = {
  r: 22,
  g: 66,
  b: 137,
};

export const GREEN = {
  r: 20,
  g: 168,
  b: 12,
};

export const RED = {
  r: 205,
  g: 15,
  b: 20,
};

export const ORANGE = {
  r: 207,
  g: 137,
  b: 15,
};

export const AQUA = {
  r: 9,
  g: 124,
  b: 124,
};

export const PURPLE = {
  r: 51,
  g: 26,
  b: 143,
};

export const YELLOW = {
  r: 207,
  g: 172,
  b: 15,
};

export function getRGBA(color, alpha = 1) {
  return `rgba(${color.r}, ${color.g}, ${color.b}, ${alpha})`;
}

export function getBackgroundRGBA(color, alpha = 0.1) {
  return getRGBA(color, alpha);
}


export function getLineDatasetColorProps(color, withBackground = true) {
  return {
    backgroundColor: withBackground ? getBackgroundRGBA(color) : getBackgroundRGBA(color, 0),
    borderColor: getRGBA(color),
    pointBackgroundColor: getRGBA(color),
  };
}

export default {
  BLUE,
  GREEN,
  RED,
  ORANGE,
  AQUA,
  PURPLE,
  YELLOW,
  getBackgroundRGBA,
  getRGBA,
};
